const backendPaths = {
    development: 'https://capture-dev-wetiwctgqq-nn.a.run.app/v1/',
    production: 'https://capture-wetiwctgqq-nn.a.run.app/v1/',
  };
  
  export default backendPaths;
  